import type { PageContext } from 'vike/types';

// i18next can't be used here
export default (pageContext: PageContext) => {
    return pageContext.locale || pageContext.defaultLocale === 'en'
        ? 'Saint Petersburg FIR | VATSIM'
        : 'РПИ Санкт-Петербург | VATSIM';
};
